import axios from "axios";
import Decimal from "decimal.js";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { TaxBudgetId, } from "../../Types";
import ValidationError from "../../ZodError";
export const TaxConsumption = z.object({
    taxBudgetAmount: z
        .string()
        .transform((v) => new Decimal(v))
        .optional(),
    netYtdLongTermGainOrLoss: z.string().transform((v) => new Decimal(v)),
    netYtdShortTermGainsOrLoss: z.string().transform((v) => new Decimal(v)),
    netYtdLongTermTaxes: z.string().transform((v) => new Decimal(v)),
    netYtdShortTermTaxes: z.string().transform((v) => new Decimal(v)),
    netYtdTaxBurden: z.string().transform((v) => new Decimal(v)),
});
const ResponseSchema = z.object({
    data: TaxConsumption,
});
const QuerySchema = z.object({
    taxBudgetId: TaxBudgetId.optional(),
});
export const url = (clientId, queryParams) => {
    let queryString = "";
    if (queryParams.taxBudgetId !== undefined) {
        const urlSearch = new URLSearchParams();
        urlSearch.append("taxBudgetId", queryParams.taxBudgetId);
        queryString = `?${urlSearch.toString()}`;
    }
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/investment/tax/tax-consumption/${clientId}${queryString}`
        : `https://middleware.uat.farther.com/investment/tax/tax-consumption/${clientId}${queryString}`;
};
export const getTaxConsumptionByClientId = async (clientId, query, config) => {
    const { data } = await axios.get(url(clientId, query), {
        headers: {
            version: "20241113",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = ResponseSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    else {
        const errorMessage = `[${getTaxConsumptionByClientId.name}] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getTaxConsumptionByClientId.js.map